var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("iframe", {
    staticClass: "white-board",
    attrs: { src: _vm.whiteBoardUrl },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }